import { useEffect, useState, useCallback } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import ComparisonView from './ComparisonView'
import AssessmentSelector from './AssessmentSelector'
import { buildCompareSearchParams, parseCompareIds } from '../utils/adminLinks'

const ComparisonPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const [assessmentIds, setAssessmentIds] = useState(null)
  const [error, setError] = useState(null)
  const [showAddModal, setShowAddModal] = useState(false)

  useEffect(() => {
    const ids = parseCompareIds(searchParams)

    if (ids.length === 0) {
      setError('Paramètre "ids" manquant dans l\'URL')
      return
    }

    if (ids.length < 2 || ids.length > 5) {
      setError('Entre 2 et 5 IDs d\'évaluation sont requis pour la comparaison')
      return
    }

    setError(null)
    setAssessmentIds(ids)
  }, [searchParams])

  const handleClose = () => {
    navigate('/admin/assessments')
  }

  const handleRemoveAssessment = useCallback((idToRemove) => {
    if (!assessmentIds || assessmentIds.length <= 2) return
    const next = assessmentIds.filter(id => id !== idToRemove)
    setSearchParams(buildCompareSearchParams(next))
  }, [assessmentIds, setSearchParams])

  const handleAddAssessments = useCallback((newIds) => {
    setShowAddModal(false)
    if (!newIds || newIds.length === 0) return
    const merged = [...new Set([...assessmentIds, ...newIds])]
    const capped = merged.slice(0, 5)
    setSearchParams(buildCompareSearchParams(capped))
  }, [assessmentIds, setSearchParams])

  if (error) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-red-50 border border-red-200 text-red-600 px-6 py-4 rounded-lg" role="alert">
          <h3 className="font-medium">Erreur</h3>
          <p>{error}</p>
        </div>
        <button
          onClick={handleClose}
          className="mt-4 text-blue-600 hover:text-blue-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded"
        >
          ← Retour à la liste
        </button>
      </div>
    )
  }

  if (!assessmentIds) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    )
  }

  const canAdd = assessmentIds.length < 5
  const canRemove = assessmentIds.length > 2

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <ComparisonView
        assessmentIds={assessmentIds}
        onClose={handleClose}
        onRemoveAssessment={canRemove ? handleRemoveAssessment : null}
        onRequestAdd={canAdd ? () => setShowAddModal(true) : null}
      />

      {showAddModal && (
        <AssessmentSelector
          excludeIds={assessmentIds}
          maxSelections={5 - assessmentIds.length}
          onSelect={handleAddAssessments}
          onClose={() => setShowAddModal(false)}
        />
      )}
    </div>
  )
}

export default ComparisonPage

